import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Location } from '@reach/router';
import { Link } from 'gatsby';

var canUseDOM = !!(
	(typeof window !== 'undefined' &&
		window.document && window.document.createElement)
);

class ZLink extends Component {
	constructor(props) {
		super(props);
		this.buttonClick = this.buttonClick.bind(this);
		this.category = 'Internal Link';
	}
	static propTypes = {
		location: PropTypes.object.isRequired
	}
	buttonClick(e) {
		window.dataLayer = window.dataLayer || [];
		let linkLocation = e.currentTarget.parentNode.getAttribute("datalayer");
		var event = {};
		event.action = e.type;
		let href = this.props.to || this.props.href;
		event.link = href;
		event.page = this.props.location.pathname;
		event.category = this.category;
		if (typeof this.props.children === 'string') {
			event.text = this.props.children;
		}
		event.location = linkLocation;
		window.dataLayer.push(event);
		if (this.props.onClick) {
			e.preventDefault();
			this.props.onClick();
		} else if (/^#\w*$/.test(href)) {
			if (canUseDOM) {
				e.preventDefault();
				if (href.length > 1) {
					const offsetTop = document.querySelector(href).offsetTop - 104; // make sure to subtract the nav height if nav is sticky
					window.scroll({
						top: offsetTop,
						behavior: "smooth"
					})
				}
			}
		}
	}
	render() {
		const scheme = /(?:https?:)?\/\/([^/]+)/i;
		const { location } = this.props;
		const trailingSlash = ('trailingSlash' in this.props ? this.props.trailingSlash : true);
		let href = this.props.to || this.props.href;
		let passthrough = Object.assign({}, this.props);
		delete passthrough.location;
		delete passthrough.to;
		delete passthrough.href;
		delete passthrough.resetOnNavigate;
		delete passthrough.reset;
		let result;
		let external = ('external' in this.props ? this.props.external : false);
		if (!('external' in this.props) && (result = scheme.exec(href)) !== null && result[1] !== location.host) {
			external = true;
			this.category = 'Outbound Link';
		}
		const className = this.props.className || '';
		if (external === false) {
			if (this.props.exactURL !== true && trailingSlash && !/\/$/.test(href) && !/^#/.test(href) && !/\.[a-z0-9]+$/.test(href) && (!!href && href.indexOf("userfiles") !== -1)) { // The third regex test ensures we don't add a trailing slash to a PDF or other file type
				href += '/';
			}
			if (href?.indexOf('userfiles') === -1) {
				if (this.props.target === '_blank') {
					return (
						<a datalayer={this.props.datalayer} onClick={this.buttonClick} className={className} href={href} target="_blank" rel="noreferrer" {...passthrough}>{this.props.children}</a>
					)
				}
				return (
					<Link datalayer={this.props.datalayer} onClick={this.buttonClick} className={className} to={href} {...passthrough}>{this.props.children}</Link>
				)
			}
		}
		return (
			<a onClick={this.buttonClick} className={className} href={href} target="_blank" rel="noopener noreferrer" {...passthrough}>{this.props.children}</a>
		)
	}
}

const TrueLink = (props) => {
	return (
		<Location>
			{locationProps => <ZLink location={locationProps.location} {...props}>{props.children}</ZLink>}
		</Location>
	)
};

export default TrueLink;